import { AuthActionTypes } from '../../actions/auth.actions';

export function clearState(reducer) {
  return function (state, action) {
    if (action.type === AuthActionTypes.LOGOUT || action.type === AuthActionTypes.CLEAR_AUTH_REQUEST) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
